var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Col, Icon, Row, themes, useOutsideClick } from '@digitools/honest-react';
import { format } from 'date-fns';
import { useState, useRef } from 'react';
import { Link as ReactLink } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import useAuthentication from '../../../hooks/useAuthentication';
import { getEnvVariable } from '../../../utils/envUtils';
import { Container } from '@digitools/honest-react';
import SupportSlideoutContainer from './components/SupportSlideoutContainer';
import SupportSlideoutButton from './components/SupportSlideoutButton';
import useTealium from '../../../hooks/useTealium';
import { TEALIUM_EVENT } from '../../../constants/tealiumConstants';
var StyledLink = styled(ReactLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  flex-grow: 1;\n  font-size: 14px;\n  font-weight: bolder;\n  height: 100%;\n  max-height: none;\n  padding: 0.8rem;\n  &:hover {\n    text-decoration: none;\n  }\n"], ["\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  flex-grow: 1;\n  font-size: 14px;\n  font-weight: bolder;\n  height: 100%;\n  max-height: none;\n  padding: 0.8rem;\n  &:hover {\n    text-decoration: none;\n  }\n"])), function (_a) {
  var _b = _a.isLogin,
    isLogin = _b === void 0 ? false : _b;
  return isLogin ? themes.default.palette.primary : null;
}, function (_a) {
  var _b = _a.isLogin,
    isLogin = _b === void 0 ? false : _b;
  return isLogin ? themes.default.palette.grayDarkest : themes.default.palette.white;
});
var StyledDiv = styled('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n  font-size: 0.875rem;\n  font-weight: bolder;\n  height: 100%;\n  max-height: none;\n  padding: 0.8rem;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n  font-size: 0.875rem;\n  font-weight: bolder;\n  height: 100%;\n  max-height: none;\n  padding: 0.8rem;\n"])));
var StyledWelcomeButton = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n  font-size: 0.875rem;\n  font-weight: bolder;\n  height: 100%;\n  max-height: none;\n  padding: 0.8rem;\n  color: ", "\n  &:after {\n    content: '';\n    margin: 0.15rem 0 0 0.35rem;\n    z-index: 25;\n    width: 0;\n    height: 0;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 8px solid ", ";\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n  font-size: 0.875rem;\n  font-weight: bolder;\n  height: 100%;\n  max-height: none;\n  padding: 0.8rem;\n  color: ", "\n  &:after {\n    content: '';\n    margin: 0.15rem 0 0 0.35rem;\n    z-index: 25;\n    width: 0;\n    height: 0;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 8px solid ", ";\n  }\n"])), themes.lincoln.palette.white, themes.lincoln.palette.grayLightest);
var StyledDivider = styled('span')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: 50%;\n  align-self: center;\n  border-right: 1px solid;\n  &:last-child {\n    border-right: none;\n  }\n"], ["\n  height: 50%;\n  align-self: center;\n  border-right: 1px solid;\n  &:last-child {\n    border-right: none;\n  }\n"])));
var StyledIcon = styled(Icon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-right: 0.5rem;\n"], ["\n  margin-right: 0.5rem;\n"])));
var StyledContainer = styled('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  align-items: center;\n  background-color: #37424a;\n  color: white;\n  padding: 0 1rem;\n"], ["\n  align-items: center;\n  background-color: #37424a;\n  color: white;\n  padding: 0 1rem;\n"])));
var StyledDropDown = styled('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  top: 100%;\n  width: 225px;\n  z-index: 2;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14);\n  background-color: #555e64;\n  &:before {\n    content: '';\n    position: absolute;\n    left: 15%;\n    top: -1px;\n    z-index: 20;\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 8px solid #37424a;\n  }\n"], ["\n  position: absolute;\n  top: 100%;\n  width: 225px;\n  z-index: 2;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14);\n  background-color: #555e64;\n  &:before {\n    content: '';\n    position: absolute;\n    left: 15%;\n    top: -1px;\n    z-index: 20;\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 8px solid #37424a;\n  }\n"])));
var StyledDropDownItem = styled(ReactLink)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  font-size: 0.875rem;\n  font-weight: bolder;\n  padding: 1.125rem;\n  text-decoration: none;\n  display: block;\n  color: ", ";\n"], ["\n  font-size: 0.875rem;\n  font-weight: bolder;\n  padding: 1.125rem;\n  text-decoration: none;\n  display: block;\n  color: ", ";\n"])), themes.lincoln.palette.grayLightest);
var UtilityHeader = function (_a) {
  var props = __rest(_a, []);
  var _b = useAuthentication(),
    user = _b.user,
    logout = _b.logout;
  var location = props.location;
  var trackEvent = useTealium().trackEvent;
  var derriveAdminHomeLink = function () {
    window.location.assign(getEnvVariable('adminApp'));
  };
  var _c = useState(false),
    isSupportSlideoutOpen = _c[0],
    setIsSupportSlideoutOpen = _c[1];
  var _d = useState(false),
    dropMenuOpen = _d[0],
    setDropMenuOpen = _d[1];
  var welcomeDivRef = useRef(null);
  var handleLogout = function () {
    logout();
    trackEvent({
      event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
      event_name: 'Lincoln Dental Provider Logout Link',
      event_type: TEALIUM_EVENT.EVENT_TYPE.H_LINK
    });
  };
  useOutsideClick([welcomeDivRef], function () {
    if (dropMenuOpen) setDropMenuOpen(!dropMenuOpen);
  });
  return _jsxs(StyledContainer, __assign({
    "aria-label": 'utility navigation',
    role: 'navigation',
    "data-public": true
  }, {
    children: [_jsx(Container, __assign({
      size: 'medium'
    }, {
      children: _jsxs(Row, {
        children: [!!user && _jsxs(Col, __assign({
          className: 'd-flex py-1 mr-auto'
        }, {
          children: [_jsxs("div", __assign({
            ref: welcomeDivRef
          }, {
            children: [_jsxs(StyledWelcomeButton, __assign({
              "data-testid": 'welcome-message',
              buttonType: 'text',
              "aria-label": 'Header Menu',
              onClick: function () {
                return setDropMenuOpen(!dropMenuOpen);
              }
            }, {
              children: [_jsx(StyledIcon, {
                color: 'white',
                name: 'profile'
              }), !!(user === null || user === void 0 ? void 0 : user.firstName) && "Welcome, ".concat(user.firstName)]
            })), dropMenuOpen && !(user === null || user === void 0 ? void 0 : user.internalAdmin) && _jsx(StyledDropDown, {
              children: _jsx(StyledDropDownItem, __assign({
                to: '/profile',
                "data-testid": 'profile-info',
                onClick: function () {
                  setDropMenuOpen(false);
                  trackEvent({
                    event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
                    event_name: 'Profile Information',
                    event_type: TEALIUM_EVENT.EVENT_TYPE.H_LINK
                  });
                }
              }, {
                children: "Profile Information"
              }))
            })]
          })), _jsx(StyledDivider, {}), !!(user === null || user === void 0 ? void 0 : user.previousLogin) && _jsxs(_Fragment, {
            children: [_jsxs(StyledDiv, __assign({
              "data-testid": 'last-login'
            }, {
              children: ["Last Login ", format(user === null || user === void 0 ? void 0 : user.previousLogin, 'MM/dd/yyyy')]
            })), _jsx(StyledDivider, {})]
          }), !(user === null || user === void 0 ? void 0 : user.internalAdmin) && _jsx(StyledLink, __assign({
            onClick: function () {
              handleLogout();
            },
            to: '#',
            "data-testid": 'logout-link',
            "aria-label": 'Log out of Lincoln Dental Provider Portal'
          }, {
            children: "LOG OUT"
          }))]
        })), _jsx(Col, __assign({
          className: 'd-flex ml-auto'
        }, {
          children: _jsxs("div", __assign({
            className: 'd-flex py-1'
          }, {
            children: [_jsx(SupportSlideoutButton, {
              openSlideout: setIsSupportSlideoutOpen
            }), _jsx(StyledDivider, {}), !!!user && location.pathname !== '/registration' && _jsx(_Fragment, {
              children: _jsxs(StyledLink, __assign({
                to: '/registration',
                onClick: function () {
                  return trackEvent({
                    event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
                    event_name: 'Lincoln Dental Provider Registration Link',
                    event_type: TEALIUM_EVENT.EVENT_TYPE.H_LINK
                  });
                },
                "aria-label": 'Go to registration page',
                "data-testid": 'registration-link'
              }, {
                children: [_jsx(StyledIcon, {
                  color: 'white',
                  name: 'user-add'
                }), "REGISTER"]
              }))
            }), (user === null || user === void 0 ? void 0 : user.internalAdmin) && _jsx(_Fragment, {
              children: _jsxs(StyledLink, __assign({
                onClick: function () {
                  return derriveAdminHomeLink();
                },
                to: '#',
                "aria-label": 'return to admin home',
                "data-testid": 'admin-link'
              }, {
                children: [_jsx(StyledIcon, {
                  color: 'white',
                  name: 'home'
                }), "ADMIN HOME"]
              }))
            })]
          }))
        }))]
      })
    })), _jsx(SupportSlideoutContainer, {
      openSlideout: setIsSupportSlideoutOpen,
      isOpen: isSupportSlideoutOpen
    })]
  }));
};
export default withRouter(UtilityHeader);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;